var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vue-images" },
    [
      _c("gallery", {
        class: _vm.gallery_class,
        attrs: {
          id: _vm.gallery_id,
          images: _vm.images,
          url: _vm.url,
          readonly: _vm.readonly
        },
        on: {
          changeIndex: function($event) {
            return _vm.changeImg($event)
          },
          removeImage: function($event) {
            return _vm.removeImg($event)
          }
        }
      }),
      _vm._v(" "),
      _vm.images.length < 1
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-12", class: _vm.gallery_class }, [
              _vm._v("No photos available.")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.readonly
        ? _c("dropzone", {
            attrs: {
              url: _vm.url,
              extra_params: _vm.extra_params,
              acceptedFileTypes: "image/*"
            },
            on: {
              "vdropzone-success": _vm.uploadSuccess,
              "vdropzone-error": _vm.alertError
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.errors.length > 0
        ? _c(
            "div",
            {
              staticClass: "alert alert-danger alert-dismissible",
              attrs: { role: "alert" }
            },
            [
              _vm.errors.length > 0
                ? _c(
                    "ul",
                    { staticClass: "list-unstyled" },
                    _vm._l(_vm.errors, function(item) {
                      return _c("li", [
                        _vm._v("\n        " + _vm._s(item) + "\n      ")
                      ])
                    }),
                    0
                  )
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShow,
              expression: "isShow"
            }
          ],
          ref: "lightbox",
          staticClass: "lightbox",
          on: {
            click: function($event) {
              _vm.isShow = !_vm.modalclose
            }
          }
        },
        [
          _c("fancybox", {
            ref: "fancybox",
            attrs: {
              entryId: _vm.entry_id,
              url: _vm.url,
              images: _vm.images,
              index: _vm.index,
              reset: !_vm.isShow,
              showclosebutton: _vm.showclosebutton,
              showcaption: _vm.showcaption,
              imagecountseparator: _vm.imagecountseparator,
              showimagecount: _vm.showimagecount
            },
            on: {
              play: _vm.playImg,
              pause: _vm.pauseImg,
              close: _vm.closeImg,
              addIndex: _vm.nextImg,
              decIndex: _vm.prevImg
            }
          }),
          _vm._v(" "),
          _c("paginator", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showthumbnails,
                expression: "showthumbnails"
              }
            ],
            attrs: { images: _vm.images, url: _vm.url, activeIndex: _vm.index },
            on: {
              changeIndex: function($event) {
                return _vm.changeImg($event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }